import { Role } from '@/enums';

export const ADMIN_ROLES = [
  Role.SUPER_ADMIN,
  Role.ADMIN,
  Role.TENANT_ADMIN,
  Role.SUPER_TENANT_ADMIN,
];
